import { TextField } from '@material-ui/core';
import React from 'react';
/**
 * Default Input field for Reference picker
 */
export const ReferenceFieldInput = props => {
  const {
    description,
    displayName,
    helperText,
    inputProps
  } = props;
  return /*#__PURE__*/React.createElement(TextField, {
    "data-test": 'reference-input',
    autoFocus: props.autoFocus,
    type: "text",
    label: displayName,
    placeholder: displayName,
    title: description,
    helperText: helperText,
    value: inputProps.value,
    InputProps: {
      ...inputProps
    },
    onBlur: ev => {
      var _inputProps$onBlur;
      return (_inputProps$onBlur = inputProps.onBlur) === null || _inputProps$onBlur === void 0 ? void 0 : _inputProps$onBlur.call(inputProps, ev);
    },
    onChange: ev => inputProps.onChange && inputProps.onChange(ev)
  });
};
//# sourceMappingURL=ReferenceFieldInput.js.map